import Reveal from '@/components/base/Reveal';
import { accent } from '@/components/feature/solution/theme';

interface Metric {
  value: string;
  label: string;
}

interface TraceVerifyProps {
  code: string;
  title: string;
  desc: string;
  metrics: Metric[];
}

export default function TraceVerify({ code, title, desc, metrics }: TraceVerifyProps) {
  const a = accent('green');

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <Reveal>
          <div className="rounded-2xl bg-background-50 border border-background-200 p-6 md:p-8">
            <div className="flex flex-col md:flex-row md:items-center gap-5 md:gap-8">
              <div className="flex items-start gap-4 flex-1">
                <span className={`w-12 h-12 shrink-0 flex items-center justify-center rounded-xl ${a.iconBox}`}>
                  <i className="ri-shield-check-line text-2xl"></i>
                </span>
                <div>
                  <div className="flex flex-wrap items-center gap-3">
                    <h2 className="font-heading font-bold text-foreground-950 text-lg md:text-xl">{title}</h2>
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${a.badgeLight}`}>
                      <i className="ri-verified-badge-line"></i>
                      溯源码 {code}
                    </span>
                  </div>
                  <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{desc}</p>
                </div>
              </div>
            </div>

            <div className="mt-6 md:mt-8 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
              {metrics.map((m) => (
                <div key={m.label} className="rounded-xl bg-background-100 border border-background-200 px-4 py-4">
                  <div className={`font-heading font-bold text-xl md:text-2xl ${a.text}`}>{m.value}</div>
                  <div className="mt-1 text-xs md:text-sm text-foreground-600">{m.label}</div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}